var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91914 0C0.64769 0 0 0.64769 0 8.91914V9.08086C0 17.3523 0.64769 18 8.91914 18H9.08086C17.3523 18 18 17.3523 18 9.08086V9C18 0.6534 17.3466 0 9 0H8.91914ZM7.2 1.8H10.8C15.808 1.8 16.2 2.19195 16.2 7.2V10.8C16.2 15.808 15.808 16.2 10.8 16.2H7.2C2.19195 16.2 1.8 15.808 1.8 10.8V7.2C1.8 2.19195 2.19195 1.8 7.2 1.8ZM13.4974 3.6C13.0001 3.60135 12.5986 4.00539 12.6 4.50264C12.6013 4.99989 13.0054 5.40135 13.5026 5.4C13.9999 5.39865 14.4013 4.99461 14.4 4.49736C14.3986 4.00011 13.9946 3.59865 13.4974 3.6ZM8.98945 4.5C6.50455 4.50585 4.49415 6.52565 4.5 9.01055C4.50585 11.4954 6.52565 13.5058 9.01055 13.5C11.4954 13.4941 13.5058 11.4744 13.5 8.98945C13.4941 6.50455 11.4744 4.49415 8.98945 4.5ZM8.99385 6.3C10.4847 6.2964 11.6964 7.503 11.7 8.99385C11.7031 10.4847 10.497 11.6964 9.00615 11.7C7.5153 11.7036 6.3036 10.4975 6.3 9.00615C6.2964 7.5153 7.503 6.3036 8.99385 6.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.29d4a57615ac36dcfc33395be57af5c7.svg";
export { ForwardRef as ReactComponent };